module.exports = __webpack_public_path__ + "img/right-arrow.8e4244af.svg";